module.exports = __webpack_public_path__ + "img/hld-action-header.2a901cdc.png";